module.exports = __webpack_public_path__ + "CraftworkGrotesk-Regular.b1f30d1abe44caf33a03.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/grotesc/CraftworkGrotesk-Regular.woff
// module id = ./src/assets/webfonts/grotesc/CraftworkGrotesk-Regular.woff
// module chunks = styles